export default {"src":"/_next/static/media/rook_bland.4e4e46fe.svg","height":245,"width":237};